module.exports = __webpack_public_path__ + "static/media/Pop Star.7f416950.jpg";